import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/shared/shared.module';
import { RepositoryComponent } from './repository.component';
import { SitesComponent } from './sites/sites.component';
import { SiteEditComponent } from './sites/site-edit/site-edit.component';
import { AddressesComponent } from './addresses/addresses.component';
import { AddressEditComponent } from './addresses/address-edit/address-edit.component';
import { ClientsComponent } from './clients/clients.component';
import { ClientEditComponent } from './clients/client-edit/client-edit.component';
import { DictionariesComponent } from './transport-types/dictionaries.component';
import { DictionaryEditComponent } from './transport-types/dictionary-edit/dictionary-edit.component';
import { ProductTypesComponent } from './product-types/product-types.component';
import { ProductTypeEditComponent } from './product-types/product-type-edit/product-type-edit.component';
import { ContainersComponent } from './containers/containers.component';
import { ContainerEditComponent } from './containers/container-edit/container-edit.component';
import { DictionaryValuesListComponent } from './transport-types/dictionary-values-list/dictionary-values-list.component';
import { LicensesComponent } from './licenses/licenses.component';
import { MomentModule } from 'ngx-moment';
import { LicenseEditComponent } from './licenses/license-edit/license-edit.component';

@NgModule({
  declarations: [
    RepositoryComponent,
    SitesComponent,
    SiteEditComponent,
    AddressesComponent,
    AddressEditComponent,
    ClientsComponent,
    ClientEditComponent,
    DictionariesComponent,
    DictionaryValuesListComponent,
    DictionaryEditComponent,
    ProductTypesComponent,
    ProductTypeEditComponent,
    ContainersComponent,
    ContainerEditComponent,
    LicensesComponent,
    LicenseEditComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    ReactiveFormsModule,
    MomentModule,
  ]
})
export class RepositoryModule { }
